module.exports = __webpack_public_path__ + "static/img/65.7ec0aad.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/65.jpg
// module id = HWqP
// module chunks = 0